import { useState } from 'react';

interface LockHeaderBannerProps {
  isHolder: boolean;
  lockedByEmail?: string;
  expiresAt: string;
  onExtend?: () => Promise<void>;
  onRelease?: () => Promise<void>;
}

function formatTime(expiresAt: string): string {
  const d = new Date(expiresAt);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function LockHeaderBanner({
  isHolder,
  lockedByEmail,
  expiresAt,
  onExtend,
  onRelease,
}: LockHeaderBannerProps) {
  const [loading, setLoading] = useState(false);
  const time = formatTime(expiresAt);

  const handle = async (fn?: () => Promise<void>) => {
    if (!fn) return;
    setLoading(true);
    try {
      await fn();
    } finally {
      setLoading(false);
    }
  };

  if (isHolder) {
    return (
      <div className="mx-6 mt-4 px-4 py-2 rounded-md bg-amber-100 text-amber-800 border border-amber-200 flex items-center justify-between text-sm">
        <span>
          <span aria-hidden className="mr-2">🔒</span>
          Vous éditez ce document jusqu'à {time}
        </span>
        <div className="flex gap-2">
          <button
            type="button"
            disabled={loading || !onExtend}
            onClick={() => handle(onExtend)}
            className="px-3 py-1 text-xs font-medium rounded bg-amber-200 hover:bg-amber-300 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Prolonger
          </button>
          <button
            type="button"
            disabled={loading || !onRelease}
            onClick={() => handle(onRelease)}
            className="px-3 py-1 text-xs font-medium rounded bg-amber-200 hover:bg-amber-300 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Libérer
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-6 mt-4 px-4 py-2 rounded-md bg-gray-100 text-gray-700 border border-gray-200 text-sm">
      <span aria-hidden className="mr-2">🔒</span>
      Verrouillé par {lockedByEmail ?? 'un autre utilisateur'} jusqu'à {time} — lecture seule
    </div>
  );
}
